module.exports = __webpack_public_path__ + "media/images/wizard-icon-1a9d9a6fa83e7cb446d9ff6b1e69f1b6.svg";